var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import Icons from './Icons/Icons';
import { formatMoney as shopifyFormat } from '@shopify/theme-currency';
import cartUtil from '../utils/cartUtil';
import { add as addProduct } from '../utils/cartUtil';
import Toast from './Toast/Toast';
import Swiper from 'swiper';
const handleize = (string) => {
    return string.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
};
const Recommendations = ({ parentClass, product, cartItems, cartTotal, upsellTitle, upsellDescription, initializeCart, productUpsells, variantsUpsells }) => {
    const [recommendedProducts, setRecommendedProducts] = useState(null);
    const [targetCartItem, setTargetCartItem] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [addingState, setAddingState] = useState('Add to cart');
    const [currentVariants, setCurrentVariants] = useState({});
    const [displayUpsell, setDisplayUpsell] = useState(true);
    const [complimentaryProduct, setComplimentaryProduct] = useState(null);
    const [removeLoading, setRemoveLoading] = useState({});
    const [currentSlide, setCurrentSlide] = useState(0);
    const previousCartTotal = useRef(null);
    const swiperRef = useRef(null);
    const swiperMoveRef = useRef(null);
    const initialLoaded = useRef(false);
    const setComplimentary = (e) => {
        let product = e.target.dataset.product;
        let variant = e.target.value;
        setComplimentaryProduct({
            product: product,
            variant: variant,
        });
    };
    const setRecommended = (cartItem, productUpsellsOverride = [], variantsUpsellsOverride = []) => __awaiter(void 0, void 0, void 0, function* () {
        let recVariants;
        if (((cartItem || {}).metafields || {}).product_upsells) {
            recVariants = [...cartItem.metafields.product_upsells];
        }
        else if (((cartItem || {}).metafields || {}).variant_upsells) {
            recVariants = [...cartItem.metafields.variant_upsells];
        }
        else if (productUpsellsOverride.length > 0) {
            recVariants = [...productUpsellsOverride];
        }
        else if (variantsUpsellsOverride.length > 0) {
            recVariants = [...variantsUpsellsOverride];
        }
        else {
            return false;
        }
        let recommendations = [];
        let variantIds = [];
        console.log(recVariants, parentClass);
        for (let i = 0; i < recVariants.length; i++) {
            let variant = recVariants[i];
            let productId = variant.product_id;
            let hasProductInd = recommendations.findIndex((product) => product.product_id == productId);
            if (hasProductInd == -1) {
                if (!recVariants[i].variants)
                    recVariants[i].variants = [];
                let cleanVariant = Object.assign({}, variant);
                delete cleanVariant.variants;
                recVariants[i].variants.push(Object.assign({}, cleanVariant));
                if (variantIds.includes(variant.id))
                    continue;
                variantIds.push(variant.id);
                recommendations.push(recVariants[i]);
            }
            else {
                let cleanVariant = Object.assign({}, variant);
                delete cleanVariant.variants;
                (recommendations[hasProductInd] || {}).variants.push(Object.assign({}, cleanVariant));
            }
        }
        recommendations = recommendations.map((product) => {
            let duplicateVariants = [];
            product.variants = product.variants.filter((variant) => {
                if (duplicateVariants.includes(variant.id))
                    return false;
                duplicateVariants.push(variant.id);
                return true;
            });
            return product;
        });
        setRecommendedProducts(recommendations);
        return true;
    });
    const recPriorityFilter = (recommendedProductsPriority, itemsFiltered) => __awaiter(void 0, void 0, void 0, function* () {
        let targetCartItem = false;
        let i = 0;
        while (!targetCartItem && i < recommendedProductsPriority.length) {
            let product = recommendedProductsPriority[i];
            i++;
            let foundItem = itemsFiltered.find((item) => item.product_id == product.id);
            if (foundItem) {
                let found = yield setRecommended(foundItem);
                if (found) {
                    targetCartItem = foundItem;
                    break;
                }
            }
        }
        return targetCartItem;
    });
    const findRecommended = () => __awaiter(void 0, void 0, void 0, function* () {
        let foundRecommended = false;
        let itemsFiltered = (cartItems || []).filter((item) => item.product_type != 'Free Gift' && item.product_type != 'First Tier Sample' && item.product_type != 'Second Tier Sample' && item.properties._upsell != 'true');
        let maxRounds = 10;
        while (!foundRecommended) {
            let recommendedProductsPriority = dataJs.cartRecommendedPriority;
            let targetCartItem = null;
            if (maxRounds == 0) {
                break;
            }
            maxRounds--;
            let foundPriority = yield recPriorityFilter(recommendedProductsPriority, itemsFiltered);
            if (foundPriority) {
                foundRecommended = true;
                targetCartItem = foundPriority;
                setTargetCartItem(targetCartItem);
                return true;
            }
            if (!targetCartItem && !foundRecommended) {
                let currentItem;
                let found = false;
                for (let i = 0; i < itemsFiltered.length; i++) {
                    currentItem = itemsFiltered[i];
                    found = yield setRecommended(currentItem);
                    if (found) {
                        foundRecommended = true;
                        break;
                    }
                }
                if (foundRecommended) {
                    setTargetCartItem(currentItem);
                    return true;
                }
            }
            setRecommendedProducts([]);
        }
    });
    // Run if cart items provided, not if product is provided
    useEffect(() => {
        if ((!!product && !cartItems) || (cartItems || []).length == 0 || (cartTotal == previousCartTotal.current && initialLoaded.current == true)) {
            return;
        }
        previousCartTotal.current = cartTotal;
        let upsellShown = false;
        let key = Object.keys(upsellShown || {})[0];
        let cartItem = (cartItems || []).find((item) => item.key == key);
        if (!cartItem) {
            upsellShown = false;
            localStorage.removeItem('upsell-shown');
        }
        initialLoaded.current = true;
        findRecommended();
    }, [cartItems, cartTotal]);
    // Run if product is provided, not if cart items are provided
    useEffect(() => {
        if (!product) {
            return;
        }
        let prodUpsells = productUpsells || [];
        if (prodUpsells.length == 0) {
            setRecommendedProducts([]);
            return;
        }
        setRecommended(false, prodUpsells);
        //let varUpsells: Array<any> = Array.isArray(Object.values(variantsUpsells)[0]) ? Object.values(variantsUpsells)[0] as any[] : [];
        //setRecommended(false, productUpsells, varUpsells);
    }, [product]);
    useEffect(() => {
        var _a;
        if (recommendedProducts && recommendedProducts.length > 1) {
            swiperRef.current = new Swiper(`${parentClass} .sidecart-recommendations__product-container.swiper`, {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 80,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                allowTouchMove: false,
            });
            if (!swiperRef.current)
                return;
            swiperRef.current.on('slideChange', (swiper) => {
                let newActiveBullet = document.querySelector(`.sidecart-recommendations .swiper-pagination-bullet:nth-child(${swiper.activeIndex + 1})`);
                let activeBullet = document.querySelector('.sidecart-recommendations .swiper-pagination-bullet.swiper-pagination-bullet-active');
                setCurrentSlide(swiper.activeIndex);
                activeBullet.classList.remove('swiper-pagination-bullet-active');
                newActiveBullet.classList.add('swiper-pagination-bullet-active');
            });
            swiperRef.current.on('touchStart', (swiper, event) => {
                if (event.target.closest('.sidecart-recommendations__product-variant')) {
                    swiperMoveRef.current = true;
                }
            });
            swiperRef.current.on('touchEnd', (swiper, event) => {
                swiperMoveRef.current = false;
                if (swiperMoveRef.current || event.target.closest('.sidecart-recommendations__product-variant')) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            });
        }
        else {
            (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
    }, [recommendedProducts]);
    useEffect(() => {
        if (!product)
            return;
        const upsellsContainer = document.querySelector('.product-upsells');
        if (!upsellsContainer)
            return;
        const handleVariantChange = (e) => {
            let { variant } = e.detail;
            let currentVariantUpsells = variantsUpsells[variant.id];
            if (currentVariantUpsells) {
                currentVariantUpsells.variants = undefined;
            }
            if (!currentVariantUpsells || (Array.isArray(currentVariantUpsells) && currentVariantUpsells.length === 0)) {
                if (productUpsells && productUpsells.length > 0) {
                    setRecommended(false, productUpsells);
                }
                else {
                    setRecommendedProducts([]);
                }
            }
            else {
                setRecommended(false, [], currentVariantUpsells);
            }
        };
        upsellsContainer.addEventListener('product-variant-change', handleVariantChange);
        return () => {
            upsellsContainer.removeEventListener('product-variant-change', handleVariantChange);
        };
    }, [productUpsells, variantsUpsells]);
    const resetButton = () => {
        setAddingState('');
        setIsAdding(false);
    };
    const addToCart = (product) => {
        let isBundle = false;
        let bundleItems = [];
        product.tags.map((tag) => {
            if (tag.indexOf('bundle_') !== -1) {
                isBundle = true;
                bundleItems.push(tag.split('_')[1]);
            }
        });
        let currentVariant = currentVariants[product.product_id];
        let productData = [
            {
                id: (currentVariant || {}).id || product.variants[0].id,
                quantity: 1,
                properties: {
                    _upsell: 'true',
                },
            },
        ];
        if (complimentaryProduct) {
            productData.push({
                id: complimentaryProduct.variant,
                quantity: 1,
                properties: {
                    _complimentary: (currentVariant || {}).id || product.variants[0].id,
                },
            });
        }
        if (isBundle) {
            productData = [];
            bundleItems.map((item) => {
                productData.push({
                    id: item,
                    quantity: 1,
                    properties: {
                        _upsell: 'true',
                    },
                });
            });
        }
        const productName = product.product_title; // Replace with dynamic value
        const productPrice = product.price; // Replace with dynamic value
        // Send data to the analytics data layer
        const sendAnalyticsData = () => {
            const upsellData = {
                event: 'upsell_add_to_cart',
                content_category: 'Product',
                content_ids: [product.id],
                content_name: productName,
                content_type: 'product_group',
                currency: 'AUD',
                num_items: 1,
                value: productPrice,
                module_type: "upsell",
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(upsellData);
        };
        // Call analytics before adding to the cart
        sendAnalyticsData();
        setIsAdding(true);
        setAddingState('product-add--adding');
        addProduct(productData)
            .then((items) => {
            if (Array.isArray(items)) {
                setIsAdding(false);
                setAddingState('product-add--added');
                const titles = items.map((item) => item.product_title).join(', ');
                Toast.show(`<b>${titles}</b> <span>${dataJs.product.addToCartToast}</span>`);
                document.querySelector('.sidecart-content__inner').scrollTo(0, document.querySelector('.sidecart-content__inner').scrollHeight);
                setTimeout(() => {
                    resetButton();
                }, 2000);
            }
            else {
                Toast.show(items === null || items === void 0 ? void 0 : items.description, 'error');
                resetButton();
            }
        })
            .catch((error) => {
            console.error(error);
            Toast.show(dataJs.product.addToCartFailed, 'error');
            resetButton();
        });
    };
    const removeFromCart = (product) => __awaiter(void 0, void 0, void 0, function* () {
        setRemoveLoading({
            [product.key]: true,
        });
        let updates = {};
        updates[product.key] = 0;
        yield cartUtil.update(updates);
        yield initializeCart();
        setRemoveLoading({
            [product.key]: false,
        });
    });
    if (!recommendedProducts || recommendedProducts.length === 0 || !displayUpsell) {
        return null;
    }
    // Runs only if cart items provided, not if product is provided
    if (!!targetCartItem) {
        if ((targetCartItem.metafields || {}).upsell_title_override)
            upsellTitle = targetCartItem.metafields.upsell_title_override;
        if ((targetCartItem.metafields || {}).upsell_description_override)
            upsellDescription = targetCartItem.metafields.upsell_description_override;
    }
    return (React.createElement("div", { className: "sidecart-recommendations" },
        React.createElement("div", { className: "sidecart-recommendations__text-container" },
            React.createElement("h3", { className: "sidecart-recommendations__title" }, upsellTitle),
            React.createElement("div", { className: "sidecart-recommendations__description", dangerouslySetInnerHTML: { __html: upsellDescription } })),
        React.createElement("div", { className: "sidecart-recommendations__product-container--arrows" },
            React.createElement("div", { className: "sidecart-recommendations__product-container swiper" },
                React.createElement("div", { className: "swiper-wrapper" }, recommendedProducts.map((recommendedProduct, index) => {
                    let currentVariant = currentVariants[recommendedProduct.product_id];
                    let isAdded = (cartItems || []).find((item) => item.variant_id == (currentVariant || {}).variant_id);
                    return (React.createElement("div", { className: "sidecart-recommendations__product swiper-slide" },
                        recommendedProduct.featured_image && React.createElement("img", { src: recommendedProduct.featured_image, alt: recommendedProduct.title, className: "sidecart-recommendations__product-image" }),
                        React.createElement("div", { className: "sidecart-recommendations__product-details" },
                            React.createElement("span", { className: "sidecart-recommendations__product-title" },
                                recommendedProduct.product_title,
                                (currentVariant || {}).variant_title && (currentVariant || {}).variant_title != 'Default Title' ? ` - ${currentVariant.variant_title}` : ''),
                            React.createElement("span", { className: "sidecart-recommendations__product-byline" }, recommendedProduct.byline),
                            recommendedProduct && ((recommendedProduct || {}).variants || []).length > 1 && (React.createElement("div", { className: "sidecart-recommendations__product-variants" }, (recommendedProduct || {}).variants.map((variant, index) => {
                                let optionClass = 'normal';
                                let isCurrent = (currentVariants[variant.product_id] || {}).id == variant.id;
                                if (variant.color && variant.color != 'false')
                                    optionClass = 'tint';
                                if (variant.title == 'Default Title')
                                    return null;
                                return (React.createElement("button", { disabled: !variant.available, "aria-disabled": !variant.available, role: "radio", key: index, onClick: () => setCurrentVariants(Object.assign(Object.assign({}, currentVariants), { [variant.product_id]: variant })), className: `sidecart-recommendations__product-variant sidecart-recommendations__product-variant--${optionClass} ${isCurrent ? 'sidecart-recommendations__product-variant--active' : ''}`, style: { backgroundColor: variant.color } }, (variant || {}).variant_title));
                            }))),
                            recommendedProduct.complimentary_product && !isAdded && (React.createElement("div", { className: "product__complimentary" },
                                React.createElement("input", { type: "checkbox", id: "complimentary", name: `complimentary-${(currentVariant || {}).id}`, value: recommendedProduct.complimentary_product, "data-product": recommendedProduct.product_id, onClick: setComplimentary }),
                                React.createElement("label", { htmlFor: "complimentary" }, recommendedProduct.complimentary_product_label))),
                            isAdded && (React.createElement("button", { className: `sidecart-recommendations__product-added__remove sidecart-recommendations__product-added__remove--mobile ${removeLoading[isAdded.key] == true ? 'sidecart-recommendations__product-added__remove--loading' : ''}`, onClick: () => removeFromCart(isAdded) },
                                React.createElement("span", { "data-text": true }, "Remove"),
                                React.createElement("span", { "data-loader": true },
                                    React.createElement(Icons.Loading, null))))),
                        isAdded ? (React.createElement("div", { className: "sidecart-recommendations__product-added" },
                            React.createElement("div", { className: "sidecart-recommendations__product-added__icon" },
                                React.createElement(Icons.Tick, null)),
                            React.createElement("button", { className: `sidecart-recommendations__product-added__remove ${removeLoading[isAdded.key] == true ? 'sidecart-recommendations__product-added__remove--loading' : ''}`, onClick: () => removeFromCart(isAdded) },
                                React.createElement("span", { "data-text": true }, "Remove"),
                                React.createElement("span", { "data-loader": true },
                                    React.createElement(Icons.Loading, null))))) : (React.createElement("button", { "data-button-type": "upsell", id: `sc-${handleize(recommendedProduct.product_title)}`, type: "button", onClick: () => addToCart(recommendedProduct), disabled: isAdding, className: `product-add product-add--ready button ${addingState}` },
                            React.createElement("div", { className: "product-add__default" },
                                React.createElement("span", { className: "product-add__text" },
                                    "Add - ",
                                    shopifyFormat(currentVariant ? currentVariant.price : recommendedProduct.price))),
                            React.createElement("div", { className: "product-add__loading" },
                                React.createElement(Icons.Loading, null)),
                            React.createElement("div", { className: "product-add__added" },
                                React.createElement(Icons.Tick, null),
                                React.createElement("span", { className: "product-add__added-text" }, "Added"))))));
                })),
                recommendedProducts.length > 1 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "swiper-button-prev" },
                        React.createElement("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("circle", { cx: "13", cy: "13", r: "12.5", fill: "white", stroke: "#C3C2C4" }),
                            React.createElement("path", { d: "M10.2202 12.8452L14.5952 8.47023C14.6156 8.44991 14.6397 8.43379 14.6662 8.42279C14.6928 8.41179 14.7213 8.40613 14.75 8.40613C14.7787 8.40613 14.8072 8.41179 14.8338 8.42279C14.8603 8.43379 14.8844 8.44991 14.9048 8.47023C14.9251 8.49056 14.9412 8.51469 14.9522 8.54124C14.9632 8.5678 14.9689 8.59626 14.9689 8.625C14.9689 8.65374 14.9632 8.6822 14.9522 8.70876C14.9412 8.73531 14.9251 8.75944 14.9048 8.77977L10.6845 13L14.9048 17.2202C14.9458 17.2613 14.9689 17.317 14.9689 17.375C14.9689 17.433 14.9458 17.4887 14.9048 17.5298C14.8637 17.5708 14.808 17.5939 14.75 17.5939C14.692 17.5939 14.6363 17.5708 14.5952 17.5298L10.2202 13.1548C10.1999 13.1344 10.1838 13.1103 10.1728 13.0838C10.1617 13.0572 10.1561 13.0287 10.1561 13C10.1561 12.9713 10.1617 12.9428 10.1728 12.9162C10.1838 12.8897 10.1999 12.8655 10.2202 12.8452Z", fill: "black" }))),
                    React.createElement("div", { className: "swiper-button-next" },
                        React.createElement("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("circle", { cx: "13", cy: "13", r: "12.5", fill: "white", stroke: "#C3C2C4" }),
                            React.createElement("path", { d: "M15.7799 13.1548L11.4049 17.5298C11.3846 17.5501 11.3604 17.5662 11.3339 17.5772C11.3073 17.5882 11.2789 17.5939 11.2501 17.5939C11.2214 17.5939 11.1929 17.5882 11.1664 17.5772C11.1398 17.5662 11.1157 17.5501 11.0954 17.5298C11.075 17.5094 11.0589 17.4853 11.0479 17.4588C11.0369 17.4322 11.0312 17.4037 11.0312 17.375C11.0312 17.3463 11.0369 17.3178 11.0479 17.2912C11.0589 17.2647 11.075 17.2406 11.0954 17.2202L15.3156 13L11.0954 8.77977C11.0543 8.73872 11.0312 8.68305 11.0312 8.625C11.0312 8.56695 11.0543 8.51128 11.0954 8.47023C11.1364 8.42919 11.1921 8.40613 11.2501 8.40613C11.3082 8.40613 11.3638 8.42919 11.4049 8.47023L15.7799 12.8452C15.8002 12.8656 15.8164 12.8897 15.8274 12.9162C15.8384 12.9428 15.844 12.9713 15.844 13C15.844 13.0287 15.8384 13.0572 15.8274 13.0838C15.8164 13.1103 15.8002 13.1344 15.7799 13.1548Z", fill: "black" }))))),
                recommendedProducts.length > 1 && React.createElement("div", { className: "swiper-pagination" })),
            recommendedProducts.length > 1 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `swiper-button-prev swiper-button-prev--outer ${currentSlide == 0 ? 'swiper-button-disabled' : ''}`, onClick: () => swiperRef.current.slidePrev(), "aria-label": "Previous" },
                    React.createElement("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("circle", { cx: "13", cy: "13", r: "12.5", fill: "white", stroke: "#C3C2C4" }),
                        React.createElement("path", { d: "M10.2202 12.8452L14.5952 8.47023C14.6156 8.44991 14.6397 8.43379 14.6662 8.42279C14.6928 8.41179 14.7213 8.40613 14.75 8.40613C14.7787 8.40613 14.8072 8.41179 14.8338 8.42279C14.8603 8.43379 14.8844 8.44991 14.9048 8.47023C14.9251 8.49056 14.9412 8.51469 14.9522 8.54124C14.9632 8.5678 14.9689 8.59626 14.9689 8.625C14.9689 8.65374 14.9632 8.6822 14.9522 8.70876C14.9412 8.73531 14.9251 8.75944 14.9048 8.77977L10.6845 13L14.9048 17.2202C14.9458 17.2613 14.9689 17.317 14.9689 17.375C14.9689 17.433 14.9458 17.4887 14.9048 17.5298C14.8637 17.5708 14.808 17.5939 14.75 17.5939C14.692 17.5939 14.6363 17.5708 14.5952 17.5298L10.2202 13.1548C10.1999 13.1344 10.1838 13.1103 10.1728 13.0838C10.1617 13.0572 10.1561 13.0287 10.1561 13C10.1561 12.9713 10.1617 12.9428 10.1728 12.9162C10.1838 12.8897 10.1999 12.8655 10.2202 12.8452Z", fill: "black" }))),
                React.createElement("div", { className: `swiper-button-next swiper-button-next--outer ${currentSlide == recommendedProducts.length - 1 ? 'swiper-button-disabled' : ''}`, onClick: () => swiperRef.current.slideNext(), "aria-label": "Next Slide" },
                    React.createElement("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("circle", { cx: "13", cy: "13", r: "12.5", fill: "white", stroke: "#C3C2C4" }),
                        React.createElement("path", { d: "M15.7799 13.1548L11.4049 17.5298C11.3846 17.5501 11.3604 17.5662 11.3339 17.5772C11.3073 17.5882 11.2789 17.5939 11.2501 17.5939C11.2214 17.5939 11.1929 17.5882 11.1664 17.5772C11.1398 17.5662 11.1157 17.5501 11.0954 17.5298C11.075 17.5094 11.0589 17.4853 11.0479 17.4588C11.0369 17.4322 11.0312 17.4037 11.0312 17.375C11.0312 17.3463 11.0369 17.3178 11.0479 17.2912C11.0589 17.2647 11.075 17.2406 11.0954 17.2202L15.3156 13L11.0954 8.77977C11.0543 8.73872 11.0312 8.68305 11.0312 8.625C11.0312 8.56695 11.0543 8.51128 11.0954 8.47023C11.1364 8.42919 11.1921 8.40613 11.2501 8.40613C11.3082 8.40613 11.3638 8.42919 11.4049 8.47023L15.7799 12.8452C15.8002 12.8656 15.8164 12.8897 15.8274 12.9162C15.8384 12.9428 15.844 12.9713 15.844 13C15.844 13.0287 15.8384 13.0572 15.8274 13.0838C15.8164 13.1103 15.8002 13.1344 15.7799 13.1548Z", fill: "black" }))))))));
};
export default Recommendations;
